/**
 * Error class thrown when required implementation was not provided.
 */
export class NotImplementedError extends Error {
    constructor(message: string) {
        super();
        this.name = 'NotImplementedError';
        this.message = message;
    }
}

/**
 * Error class thrown on configuration error.
 */
export class InvalidConfigurationError extends Error {
    constructor(message: string) {
        super();
        this.name = 'InvalidConfigurationError';
        this.message = message;
    }
}
